import React, { useEffect } from 'react';
import { XMarkIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Automation } from '../../types/automatisation.types';
import { useAutomationLogs } from '../../hooks/useAutomatisation';
import './ExecutionHistory.css';

interface ExecutionHistoryProps {
  isOpen: boolean;
  onClose: () => void;
  automation: Automation;
}

export const ExecutionHistory: React.FC<ExecutionHistoryProps> = ({
  isOpen,
  onClose,
  automation
}) => {
  const { logs, isLoading, refetch } = useAutomationLogs(automation.id, isOpen);

  useEffect(() => {
    if (isOpen) {
      refetch();
    }
  }, [isOpen, refetch]);

  if (!isOpen) return null;

  return (
    <div className="admin-automatisation-history-overlay">
      <div className="admin-automatisation-history-modal">
        <div className="admin-automatisation-history-header">
          <h2 className="admin-automatisation-history-title">
            Historique d'exécution - {automation.name}
          </h2>
          <button onClick={onClose} className="admin-automatisation-history-close">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="admin-automatisation-history-content">
          {isLoading ? (
            <div className="admin-automatisation-history-loading">Chargement...</div>
          ) : logs.length === 0 ? (
            <div className="admin-automatisation-history-empty">
              <p>Aucune exécution enregistrée</p>
            </div>
          ) : (
            <div className="admin-automatisation-history-list">
              {logs.map((log) => (
                <div key={log.id} className="admin-automatisation-history-item">
                  <div className="admin-automatisation-history-item-status">
                    {log.status === 'success' ? (
                      <CheckCircleIcon className="admin-automatisation-history-icon-success" />
                    ) : (
                      <XCircleIcon className="admin-automatisation-history-icon-error" />
                    )}
                  </div>
                  <div className="admin-automatisation-history-item-content">
                    <div className="admin-automatisation-history-item-header">
                      <span className="admin-automatisation-history-item-date">
                        {format(new Date(log.executed_at), 'dd MMM yyyy à HH:mm:ss', { locale: fr })}
                      </span>
                      <span className={`admin-automatisation-history-item-status-badge ${log.status}`}>
                        {log.status === 'success' ? 'Succès' : 'Échec'}
                      </span>
                    </div>
                    {log.task_message && (
                      <p className="admin-automatisation-history-item-message">
                        Tâche créée: {log.task_message}
                      </p>
                    )}
                    {log.error_message && (
                      <p className="admin-automatisation-history-item-error">
                        Erreur: {log.error_message}
                      </p>
                    )}
                    {log.execution_duration_ms && (
                      <p className="admin-automatisation-history-item-duration">
                        Durée: {log.execution_duration_ms}ms
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};